<div class="list-outer">
  <div class="list-main theme-background-color">
    <div class="list-top">
      <div class="list-header">
        <h2 class="list-title">{{ headerText }}</h2>
        <button
          mat-icon-button
          *ngIf="allowDisplayOfRecentlyCompleted"
          (click)="toggleShowRecentlyCompleted()"
          aria-label="Show/hide recently completed tasks"
          [ngClass]="{ 'show-recently-completed': showRecentlyCompleted }"
        >
          <mat-icon>remove_done</mat-icon>
        </button>
        <button
          *ngIf="!preventDragAndEdit"
          mat-icon-button
          (click)="addNewTaskAtStart()"
          aria-label="Add new task at the top of this list."
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <a
        routerLink="/org/{{ orgId }}/space/{{ spaceId }}/completed-history"
        queryParamsHandling="preserve"
      >
        <h4
          class="recent-completed-header"
          *ngIf="this.countCompletedTasks.length"
        >
          {{ this.countCompletedTasks.length }} completed tasks this week.
        </h4>
      </a>
    </div>

    <div
      *ngIf="showMoreAbove"
      class="show-more show-more-above"
      (click)="scrollUp()"
    >
      ↑ More tasks ↑
    </div>

    <div #listScroller class="task-list narrow-scrollbar">
      <div
        *ngFor="let taskItem of taskItems; let i = index"
        [id]="taskItem.taskContainerId"
      >
        <div *ngIf="!taskItem.visible" [style.height]="taskItem.height"></div>
        <app-task
          *ngIf="taskItem.visible"
          [listId]="listId"
          [listFilter]="listFilterInternal"
          [orgId]="orgId"
          [spaceId]="spaceId"
          [taskId]="taskItem.taskId"
          [contextDepth]="0"
          [siblings]="taskItems"
          [moveCursorToDeepestChild]="
            moveCursorToDeepestChildTaskId === taskItem.taskId
              ? { atStart: moveCursorToDeepestChildAtStart }
              : undefined
          "
          (moveCursorToPriorEmitter)="
            moveCursorToPrior($event.atStart, taskItems[i - 1])
          "
          (moveCursorToNextEmitter)="
            moveCursorToNext($event.atStart, taskItems[i + 1])
          "
          [preventDragAndEdit]="preventDragAndEdit"
        ></app-task>
      </div>

      <div
        *ngIf="taskItems.length === 0"
        class="empty-list-element"
        [ngClass]="{ 'drag-highlight': dragHighlight }"
        (dragover)="dragOver($event)"
        (dragleave)="dragLeave($event)"
        (drop)="dragDrop($event)"
      ></div>
    </div>

    <div
      *ngIf="showMoreBelow"
      class="show-more show-more-below"
      (click)="scrollDown()"
    >
      ↓ More tasks ↓
    </div>

    <div *ngIf="!preventDragAndEdit" class="add-task-button-container">
      <button mat-button (click)="addNewTaskAtEnd()">
        <mat-icon mat-button-icon>add</mat-icon>
        Add task
      </button>
    </div>
  </div>
  <div></div>
</div>
